<template>
  <div class="board-search">
    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
      <b-card no-body>
        <b-card-header>
          <strong>検索</strong>
        </b-card-header>
        <b-card-body>
          <b-form-group label="投稿日:" label-cols-md="2" label-align-md="right">
            <b-input-group>
              <b-form-input type="date" v-model="conditions.created_at_start" />
              <b-input-group-text>～</b-input-group-text>
              <b-form-input type="date" v-model="conditions.created_at_end" />
            </b-input-group>
          </b-form-group>
          <b-form-group label="ユーザー:" label-cols-md="2" label-align-md="right">
            <b-form-checkbox-group
              v-model="conditions.users"
              buttons
              button-variant="outline-primary"
            >
              <b-form-checkbox value="my">自身のみ</b-form-checkbox>
              <b-form-checkbox value="other">自身以外</b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
          <b-form-group label="タイトル:" label-cols-md="2" label-align-md="right">
            <b-form-input v-model="conditions.subject" placeholder="タイトル" />
          </b-form-group>
          <b-form-group label="本文:" label-cols-md="2" label-align-md="right">
            <b-form-input v-model="conditions.message" placeholder="本文" />
          </b-form-group>
        </b-card-body>
        <b-card-footer>
          <b-button type="submit" variant="primary">検索</b-button>
          <b-button type="reset" variant="outline-primary">リセット</b-button>
        </b-card-footer>
      </b-card>
    </b-form>
  </div>
</template>

<script>
const defaultConditions = {
  created_at_start: '',
  created_at_end: '',
  users: ['my', 'other'],
  subject: '',
  message: '',
};

export default {
  name: 'BoardSearch',

  data() {
    return {
      conditions: Object.assign({}, defaultConditions),
    };
  },

  methods: {
    onSubmit(evt) {
      let options = {
        limit: this.$store.state.posts.limit,
        page: 1,
        sortBy: this.$store.state.posts.sortBy,
        sortDesc: this.$store.state.posts.sortDesc,
        conditions: this.conditions,
      };
      this.$store.dispatch('posts/searchList', options);
    },

    onReset(evt) {
      this.conditions = Object.assign({}, defaultConditions);
      let options = {
        limit: this.$store.state.posts.limit,
        page: 1,
        sortBy: this.$store.state.posts.sortBy,
        sortDesc: this.$store.state.posts.sortDesc,
        conditions: this.conditions,
      };
      this.$store.dispatch('posts/searchList', options);
    }
  },
};
</script>

<style scoped>
</style>
